module.exports = __webpack_public_path__ + "img/build-external-painting.16681d25.jpg";